(window as any).global = window;
import 'zone.js'; // Included with Angular CLI.